import { Text } from "@chakra-ui/react";

const NotFound = () => <Text>La página solicitada no existe</Text>;
export default NotFound;
